'use client';

import { AnimatedLink } from '@/components/AnimatedLink';
import { IHomeDictionary } from '@/dictionaries/pages/home/types';
import Image from 'next/image';
import Slider, { Settings } from 'react-slick';

type IHomePressProps = {
  dict: IHomeDictionary;
};

const settings: Settings = {
  dots: false,
  infinite: true,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  dotsClass: 'carousel-dots',
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const imagesSourcesWithAlt = [
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc58382d4835.png`,
    alt: `The Times`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc5831b9f7b0.png`,
    alt: `The Guardian`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/6239e32c24a06.png`,
    alt: `Business Traveller`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc5816202c8b.png`,
    alt: `Cosmopolitan`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc57d1f639e3.png`,
    alt: `Country & Town House`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc582f0cd2ea.png`,
    alt: 'Sainsbury`s Magazine',
  },
];

export function HomePress({ dict }: IHomePressProps) {
  return (
    <>
      <section className="pt-32 max-w-default mx-auto px-sm md:px-md desktop:px-lg relative">
        <div className="absolute bg-gray-100 w-[120vw] left-1/2 top-[52%] -translate-x-1/2 -translate-y-1/2 h-[70%] z-0 rotate-3" />
        <div className="text-center mb-20 relative">
          <h2 className="text-4xl font-title mb-2">{dict.press.title}</h2>
          <p className="text-lg mt-5 mb-20 text-gray-850 max-w-[90%] mx-auto">
            {dict.press.description}
          </p>
        </div>

        <div className="relative mb-20">
          <Slider
            className="about-us-press-articles-carousel w-full mb-[30px] mx-0"
            {...settings}>
            {imagesSourcesWithAlt.map((img) => (
              <div key={img.alt} className="!flex justify-center">
                <Image
                  width={240}
                  height={40}
                  alt={img.alt}
                  src={img.src}
                  className="w-auto max-h-[40px] align-middle max-w-full h-auto"
                />
              </div>
            ))}
          </Slider>
        </div>

        <div className="flex justify-center relative">
          <AnimatedLink
            href={dict.press.cta.href}
            target="_blank"
            className="w-fit py-[20px] px-[10px] mt-0 desktop:px-[40px] desktop:w-fit">
            {dict.press.cta.title}
          </AnimatedLink>
        </div>
      </section>
    </>
  );
}
